/**
 * Interfaces du portail d'administration et droits associés.
 *
 * Partagé entre le backend (contrôle des droits) et le navigateur (tuiles du
 * portail, cases à cocher de la gestion des accès). Une clé ajoutée ici devient
 * un droit attribuable ; elle doit rester stable car elle est enregistrée en base.
 *
 * Le droit `access` (administrateur) donne accès à toutes les interfaces.
 */

const ADMIN_INTERFACES = [
  {
    key: 'mail',
    label: 'E-mails automatiques',
    description: 'Modèles Mailjet, profils étudiants, étapes de déclenchement et suivi des envois.',
    path: '/admin/mails',
    icon: 'send'
  },
  {
    key: 'exchanges',
    label: 'Étudiants en échange',
    description: 'Sessions, dossiers et imports des étudiants en échange.',
    path: '/admin/echanges',
    icon: 'globe'
  },
  {
    key: 'salesforce',
    label: 'Formulaires et correspondances',
    description: 'Modifier le modèle des échanges et les correspondances des formulaires vers Salesforce.',
    path: '/admin/salesforce',
    icon: 'link'
  },
  {
    key: 'access',
    label: 'Gestion des accès',
    description: 'Comptes administratifs et droits sur chaque interface.',
    path: '/admin/acces',
    icon: 'shield',
    superadmin: true
  }
];

const FORM_INTERFACES = [
  { key: 'salesforce:inscription', label: 'Formulaires et correspondances · Inscription' },
  { key: 'salesforce:candidature', label: 'Formulaires et correspondances · Candidature' },
  { key: 'salesforce:echange', label: 'Formulaires et correspondances · En échange' }
];
const ACCESS_INTERFACES = ADMIN_INTERFACES.flatMap(item => item.key === 'salesforce' ? FORM_INTERFACES : [item]);
const INTERFACE_KEYS = [...ADMIN_INTERFACES.map(item => item.key), ...FORM_INTERFACES.map(item => item.key)];

// Compatibilité : un ancien droit global conserve ses trois rubriques.
// À la prochaine modification des accès, il devient trois droits explicites.
function explicitPermissions(granted) {
  const list = (Array.isArray(granted) ? granted : []).filter(key => INTERFACE_KEYS.includes(key));
  return [...new Set(list.flatMap(key => key === 'salesforce' ? FORM_INTERFACES.map(item => item.key) : [key]))];
}
const SUPERADMIN_KEY = 'access';

/** Droits réellement ouverts : l'administrateur reçoit toutes les interfaces. */
function effectivePermissions(granted) {
  const list = explicitPermissions(granted);
  return list.includes(SUPERADMIN_KEY) ? INTERFACE_KEYS.slice() : list;
}

function hasPermission(granted, key) {
  const permissions = effectivePermissions(granted);
  return key === 'salesforce' ? FORM_INTERFACES.some(item => permissions.includes(item.key)) : permissions.includes(key);
}

module.exports = { ADMIN_INTERFACES, ACCESS_INTERFACES, FORM_INTERFACES, explicitPermissions, INTERFACE_KEYS, SUPERADMIN_KEY, effectivePermissions, hasPermission };
